import { reduce } from "et3-type-guards";
import getKhattabatStore from "../../../../stores/khattabat-stores";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Conversation from "../conversation";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../core/et3-div";

const ClientConversations = withLiteObserverAndTheme<{
  alkhattabaUUID: string;
  userUUID: string;
  isValidSubscription: boolean;
  unreadOneOOneCMessages: number;
  isOneOOneCHiddenByKhattaba: boolean;
  clientID: number;
  oneOOneCId: string;
  applicationStatus: string
}>((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;

  const {
    alkhattabaUUID,
    userUUID,
    isValidSubscription,
    unreadOneOOneCMessages,
    isOneOOneCHiddenByKhattaba,
    clientID,
    oneOOneCId,
    applicationStatus
  } = props;
  const clientConversationID = oneOOneCId
  const conversations =
    getKhattabatStore().clientConversations.get(clientConversationID);
  const oneOTwoMessagesMatchesObject = reduce(
    () => conversations.oneOTwoMessages,
    {}
  );
  const oneOTwoConversationsIds = Object.keys(oneOTwoMessagesMatchesObject);
  const shouldShowConversations = reduce(
    () =>
      getKhattabatStore().clientConversations.get(clientConversationID)
        .shouldShowConversations,
    false
  );
  return !shouldShowConversations ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="space-between"
      alignItems="center"
      withShadow={true}
      width={1450}
      height={0}
      color={colors.all.white}
      style={{
        borderRadius: 30 * unitX,
        overflow: "hidden"
      }}
      onClick={() => { }}
    >
      <Conversation
        conversationType={"101C"}
        oneOTwoConversationId=""
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        isValidSubscription={isValidSubscription}
        clientConversationID={clientConversationID}
        unreadOneOOneCMessages={unreadOneOOneCMessages}
        conversationIndex={0}
        isOneOOneCHiddenByKhattaba={isOneOOneCHiddenByKhattaba}
        clientID={clientID}
        oneOOneCId={oneOOneCId}
        applicationStatus={applicationStatus}
      />

      <Conversation
        conversationType={"101C_COMMENTS"}
        oneOTwoConversationId=""
        alkhattabaUUID={alkhattabaUUID}
        userUUID={userUUID}
        isValidSubscription={isValidSubscription}
        clientConversationID={clientConversationID}
        unreadOneOOneCMessages={unreadOneOOneCMessages}
        conversationIndex={0}
        isOneOOneCHiddenByKhattaba={isOneOOneCHiddenByKhattaba}
        clientID={clientID}
        oneOOneCId={oneOOneCId}
        applicationStatus={applicationStatus}
      />

      {oneOTwoConversationsIds.map((oneOTwoConversationId, index) => {
        return (
          <Conversation
            conversationType={"102"}
            oneOTwoConversationId={oneOTwoConversationId}
            alkhattabaUUID={alkhattabaUUID}
            userUUID={userUUID}
            isValidSubscription={false}
            clientConversationID={clientConversationID}
            unreadOneOOneCMessages={unreadOneOOneCMessages}
            conversationIndex={index + 1}
            isOneOOneCHiddenByKhattaba={false}
            clientID={clientID}
            oneOOneCId={oneOOneCId}
            applicationStatus={applicationStatus}
          />
        );
      })}
      <Et3Margin top={10} bottom={10} left={0} right={0} />
    </ET3Div>
  );
});

export default ClientConversations;
